
import { prop, Vue } from "vue-class-component";

class Props {
  show = prop<boolean>({
    default: false
  });
}
export default class OtpDisclaimer extends Vue.with(Props) {}
